export default __webpack_public_path__ + "static/media/7.f92c3058.jpg";